module.exports = __webpack_public_path__ + "static-portal/img/watermark.a55780f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/secondary/watermark.png
// module id = x/M1
// module chunks = 4